module.exports = __webpack_public_path__ + "static/img/bzx.744b36b7.png";